import { useModule } from '~/templates';
import { usePage } from '~/templates/pages';

export const useHeadlineTag = () => {
    const { index = 0 } = useModule();
    const { hiddenH1 } = usePage();
    const hasHiddenHeadline = Boolean(hiddenH1);

    const tagName: 'h1' | 'h2' = index === 0 && !hasHiddenHeadline ? 'h1' : 'h2';

    return tagName;
};
